import { faCircleDot } from '@fortawesome/pro-regular-svg-icons/faCircleDot';
import {
  type FC, useCallback,
} from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  startShapeDraw, stopShapeDraw,
} from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.actionCreators';
import { useIsShapeDrawActiveSelector } from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.selectors';
import {
  ShapeDrawConfiguration, ShapeDrawShape,
} from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.state';
import { RightSideMapToolsMenuItem } from './rightSideMapToolsMenuItem.component';

export const RightSideAddIndividualRadiusItem: FC = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const isActive = useIsShapeDrawActiveSelector();

  const toggle = useCallback(() => (
    isActive
      ? dispatch(stopShapeDraw())
      : dispatch(startShapeDraw({
        shape: ShapeDrawShape.Circle,
        configuration: ShapeDrawConfiguration.CreateIndividualProximity,
      }))
  ), [dispatch, isActive]);

  return (
    <RightSideMapToolsMenuItem
      icon={faCircleDot}
      active={isActive}
      onClick={toggle}
      tooltip={t('Add Radius')}
    />
  );
};
